function Test() {
  return (
    <h1 className="text-3xl pt-24 pl-24">
      Test
    </h1>
  );
}

export default Test;
